import { FC, ReactNode, useEffect, useRef, useState } from "react";
import { Box, BoxProps } from "@chakra-ui/react";

interface ScrollRevealProps extends BoxProps {
  children: ReactNode;
  delay?: number;
}

export const ScrollReveal: FC<ScrollRevealProps> = ({
  children,
  delay = 0,
  ...props
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            setIsVisible(true);
          }, delay);
        }
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -100px 0px",
      }
    );

    const currentElement = elementRef.current;
    if (currentElement) {
      observer.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
    };
  }, [delay]);

  return (
    <Box
      ref={elementRef}
      opacity={isVisible ? 1 : 0}
      transform={isVisible ? "translateY(0)" : "translateY(30px)"}
      transition="opacity 0.6s ease-out, transform 0.6s ease-out"
      {...props}
    >
      {children}
    </Box>
  );
};
